// extracted by mini-css-extract-plugin
export default {"counterSection":"Counter_counterSection__dhwmZ","counterItem":"Counter_counterItem__ti8B0","withBorder":"Counter_withBorder__FeWTy","innerCount":"Counter_innerCount__acKBA"};